import { render, staticRenderFns } from "./Epoint.vue?vue&type=template&id=21fc9339&scoped=true"
import script from "./Epoint.vue?vue&type=script&lang=js"
export * from "./Epoint.vue?vue&type=script&lang=js"
import style0 from "./Epoint.vue?vue&type=style&index=0&id=21fc9339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc9339",
  null
  
)

export default component.exports